import { BaseResponse, Notification } from '@yleisradio/areena-types';

export class FetchError extends Error {
  notifications: Notification[] | undefined;

  constructor(message: string, responseJson: BaseResponse | null | undefined) {
    super(message);
    this.name = this.constructor.name;
    this.notifications = responseJson?.notifications;

    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

export class NotFoundError extends FetchError {}
